export const spinAnimation = {
  from: { transform: "rotate(0deg)" },
  to: { transform: "rotate(360deg)" },
};
